import AuthManager from "@/common/auth/Manager";

const isAuthorized = (to, from, next) => {
  if (!AuthManager.isGuest() && AuthManager.can('view_therapists')) {
    next();
  } else {
    next({name: 'login'})
  }
};

export default isAuthorized;



// WEBPACK FOOTER //
// ./src/modules/user/therapist/routes/hooks/canViewTherapists.js